import { IMenuKeyboardNavigationUtils } from '@frontstoreRwd/modules/rwd_menu/menu_navigation/menu_keyboard_navigation_utils_types';
import { MENU_CSS_CLASSES, MENU_SELECTORS } from '@frontstoreRwd/modules/rwd_menu/menu_navigation/menu_keyboard_navigation_constants';

export class MenuKeyboardNavigationUtils implements IMenuKeyboardNavigationUtils {
    public $topLevelLinks: HTMLAnchorElement[] = [];
    public $topLevelItemsWithSubmenu: HTMLLIElement[] = [];

    constructor($menuBar: HTMLElement) {
        this.$topLevelLinks = this.getDirectChildLinksFromContainer($menuBar);

        this.$topLevelItemsWithSubmenu = [...$menuBar.querySelectorAll<HTMLLIElement>(`li.${MENU_CSS_CLASSES.parent}`)].filter(($menuItem) => {
            const isSubmenuExpandableItem = $menuItem.closest<HTMLElement>(`.${MENU_CSS_CLASSES.submenu}`);
            return !isSubmenuExpandableItem;
        });
    }

    public getDirectChildLinksFromContainer($menuContainer: HTMLElement): HTMLAnchorElement[] {
        const $directMenuLinks = [...$menuContainer.querySelectorAll<HTMLAnchorElement>(`:scope > ul > ${MENU_SELECTORS.linkInsideMenuItem}`)];

        return $directMenuLinks;
    }

    public getAllLinksInCurrentLevel($menuLink: HTMLAnchorElement): HTMLAnchorElement[] {
        const $parentList = $menuLink.closest('ul');

        if (!$parentList) return [];

        const $allMenuLinks = [...$parentList.querySelectorAll<HTMLAnchorElement>(`:scope > ${MENU_SELECTORS.linkInsideMenuItem}`)];

        return $allMenuLinks;
    }

    public openMenu($menuItem: HTMLLIElement): void {
        const $menuLink = $menuItem.querySelector<HTMLAnchorElement>('a[aria-haspopup="true"]');

        if (!$menuLink) return;

        $menuItem.classList.add(MENU_CSS_CLASSES.opened);
        $menuLink.setAttribute('aria-expanded', 'true');

        const $submenu = $menuItem.querySelector<HTMLElement>(`.${MENU_CSS_CLASSES.submenu}`);

        if (!$submenu) return;

        const $subMenuLinks = [...$submenu.querySelectorAll('a')];

        $subMenuLinks[0]?.focus();
    }

    public hideMenu($menuItem: HTMLLIElement): void {
        const $openedSubMenus = [...$menuItem.querySelectorAll<HTMLElement>(`.${MENU_CSS_CLASSES.opened}`)];

        $openedSubMenus.forEach(($openedSubMenu) => {
            $openedSubMenu.querySelector<HTMLAnchorElement>('a[aria-haspopup]')?.setAttribute('aria-expanded', 'false');
            $openedSubMenu.classList.remove(MENU_CSS_CLASSES.opened);
        });

        $menuItem.classList.remove(MENU_CSS_CLASSES.opened);

        const $menuLink = $menuItem.querySelector<HTMLAnchorElement>('a[aria-haspopup="true"]');
        $menuLink?.setAttribute('aria-expanded', 'false');
    }

    public hideSubMenu($subMenuLink: HTMLAnchorElement): void {
        const $subMenuItem = $subMenuLink.closest<HTMLLIElement>(`.${MENU_CSS_CLASSES.parent}`);

        if ($subMenuItem && this.$topLevelItemsWithSubmenu.includes($subMenuItem)) {
            this.hideMenu($subMenuItem);
            return;
        }

        const $parentMenuItem = $subMenuLink.closest('ul')?.closest<HTMLLIElement>(`.${MENU_CSS_CLASSES.parent}`);

        $parentMenuItem?.classList?.remove(MENU_CSS_CLASSES.opened);

        const $parentMenuLink = $parentMenuItem?.querySelector<HTMLAnchorElement>('a[aria-haspopup="true"]');

        $parentMenuLink?.setAttribute('aria-expanded', 'false');
        $parentMenuLink?.focus();
    }

    public openPreviousTopLevelMenu($currentlyFocusedMenuLink: HTMLAnchorElement): void {
        const $previousLink = this.getPreviousTopLevelLink($currentlyFocusedMenuLink);
        const $previousMenuItem = $previousLink?.closest<HTMLLIElement>(`.${MENU_CSS_CLASSES.parent}`);

        if (!$previousMenuItem) return;

        this.openMenu($previousMenuItem);
    }

    public openNextTopLevelMenu($currentlyFocusedMenuLink: HTMLAnchorElement): void {
        const $previousLink = this.getNextTopLevelLink($currentlyFocusedMenuLink);
        const $previousMenuItem = $previousLink?.closest<HTMLLIElement>(`.${MENU_CSS_CLASSES.parent}`);

        if (!$previousMenuItem) return;

        this.openMenu($previousMenuItem);
    }

    public getPreviousTopLevelLink($menuLink: HTMLAnchorElement): HTMLAnchorElement {
        const currentIndex = this.$topLevelLinks.indexOf($menuLink);
        const $previousLink = this.$topLevelLinks[currentIndex - 1] || this.$topLevelLinks.at(-1);

        return $previousLink;
    }

    public getNextTopLevelLink($menuLink: HTMLAnchorElement): HTMLAnchorElement {
        const currentIndex = this.$topLevelLinks.indexOf($menuLink);
        const $nextLink = this.$topLevelLinks[currentIndex + 1] || this.$topLevelLinks[0];

        return $nextLink;
    }
}
